/**
 * MCP Connections Add Approval Store
 *
 * Manages the state of connection-add approval requests from AI agents.
 * Used by useMcpUiControl hook and McpConnectionsAddApprovalDialog component.
 */

import { create } from 'zustand';
import type { McpConnectionsAddApprovalRequest } from '../../../types/mcpUiControl';

type ConnectionsAddApprovalState = {
  /** Currently pending connections-add approval request */
  pendingRequest: McpConnectionsAddApprovalRequest | null;

  /** Set a new pending request */
  setPendingRequest: (request: McpConnectionsAddApprovalRequest | null) => void;

  /** Approve the current request */
  approveRequest: (requestId: string) => void;

  /** Deny the current request */
  denyRequest: (requestId: string) => void;
};

export const useConnectionsAddApprovalStore = create<ConnectionsAddApprovalState>((set, get) => ({
  pendingRequest: null,

  setPendingRequest: (request) => {
    set({ pendingRequest: request });
  },

  approveRequest: (requestId) => {
    const { pendingRequest } = get();
    if (pendingRequest && pendingRequest.requestId === requestId) {
      // Send approval response to main process
      window.electronAPI?.mcpUiControl?.sendConnectionsAddApprovalResponse(requestId, true);
      window.electronAPI?.analytics?.track('ui:mcp_connection_add_approved', {}).catch(() => {});
      set({ pendingRequest: null });
    }
  },

  denyRequest: (requestId) => {
    const { pendingRequest } = get();
    if (pendingRequest && pendingRequest.requestId === requestId) {
      // Send denial response to main process
      window.electronAPI?.mcpUiControl?.sendConnectionsAddApprovalResponse(requestId, false);
      window.electronAPI?.analytics?.track('ui:mcp_connection_add_denied', {}).catch(() => {});
      set({ pendingRequest: null });
    }
  },
}));
